<ion-card
  button="true"
  [routerLink]="[`/tabs/${AppTab.FREIGHT_AVAILABLE}`]"
  routerDirection="root"
  routerLinkActive="active"
>
  <ion-card-header mode="ios">
    <ion-card-title color="white">
      {{ 'market.find_new_freights' | translate }}
    </ion-card-title>
    <ion-card-subtitle color="white">
      {{ 'market.visit_market' | translate }}
    </ion-card-subtitle>
  </ion-card-header>
  <ion-card-content class="ion-text-end">
    <ion-button color="white">{{ 'market.view_market' | translate }}</ion-button>
  </ion-card-content>
</ion-card>
